module.exports = __webpack_public_path__ + "fonts/Roboto-700-latin-ext56.a6323dd.woff2";